// extracted by mini-css-extract-plugin
export default {"Information":"Information_Information__g0HGS","wrapper":"Information_wrapper__yFRpE"};